/**
 * Translation files index
 * Exports all translations and provides a lookup function
 */

import type { Translations } from '../utils/i18n';
import type { MapLanguage } from '../types';
import { en } from './en';
import { zhHans } from './zh-Hans';
import { zhHant } from './zh-Hant';
import { es } from './es';
import { fr } from './fr';
import { de } from './de';
import { ja } from './ja';
import { ko } from './ko';

/**
 * All translations indexed by language code
 */
export const translations: Translations = {
  en,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
  es,
  fr,
  de,
  ja,
  ko,
};

/**
 * Get translations for a specific language
 * @param language - Language code
 * @returns Translation keys for the language
 */
export function getTranslations(language: MapLanguage) {
  return translations[language] || translations.en;
}

